import { SlideOpening } from './SlideOpening'
import type { SlideId } from './SlideShell'

/** ESTEVE × Snakker — the Caprelsa deck. */
export const slides = [SlideOpening]

export const slideTitles: { id: SlideId; section: string; title: string }[] = [
  { id: 'opening', section: '01', title: 'A Small Idea for ESTEVE' },
]
